const splitPrecedence = [' ', '"', '-', '.'];
const protectedSegments = ['I', 'II', 'III', 'IV', 'V'];

const cleanSegment = (segment, character) => {
  const currentCharacterIndex = splitPrecedence.indexOf(character);
  const nextSplitCharacter = splitPrecedence[currentCharacterIndex + 1];
  return segment
    .split(character)
    .map(segment => {
      if(protectedSegments.includes(segment)) return segment;
      if(segment?.length < 1) return segment;
      if(nextSplitCharacter) return cleanSegment(segment, nextSplitCharacter);

      let segmentCapped = segment.slice(0, 1) + segment.slice(1).toLowerCase();
      if(segmentCapped.startsWith('Mc') && segmentCapped?.length > 2) segmentCapped = 'Mc' + segment.slice(2, 3) + segment.slice(3).toLowerCase();
      if(segmentCapped.startsWith('(') && segmentCapped?.length > 1) segmentCapped = '(' + segment.slice(1, 2).toUpperCase() + segment.slice(2).toLowerCase();
      return segmentCapped;
    })
    .join(character);
};

export function name(input) {
  let cleanName = input.trim().replace(/\s\s+/g, ' ').toUpperCase();
  cleanName = cleanSegment(cleanName, ' ');

  return cleanName;
}
